import * as React from 'react'
import './styles.css'
// assets
import ResourcesImage from '../../../../../assets/imgs/mwm/mwm-resources.png'

const Resources = () => (
  <section className={'resources-wrapper'}>
    <h2 className={'resources-title'}>Resources</h2>
    <div className={'resources-content'}>
      <a
        className={'resources-link'}
        href={'https://www.stemconnector.com/resources/#mwm'}
        target='_parent'
      >
        <img
          className={'resources-image'}
          src={ResourcesImage}
          alt='mwm-afghanistan-logos'
          title='mwm-afghanistan-logos'
          loading={'lazy'}
        />
      </a>
    </div>
  </section>
)

export default Resources
